// extracted by mini-css-extract-plugin
module.exports = {"card":"SwishComponent__card__6PRSG","header":"SwishComponent__header__O0gca","info":"SwishComponent__info__8r6Re","web":"SwishComponent__web__Cokft"};